import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddressView } from "../../parameters/AddressView";
import PriceUpdates from "./PriceUpdates";
const RwaPreview = ({ preview }) => {
    const { redemptionGateway, priceUpdates } = preview;
    return (_jsxs("div", { className: "flex flex-col gap-y-2", children: [_jsxs("div", { className: "grid grid-cols-values-2 border-x border-b", children: [_jsx("div", { className: "w-64 font-bold p-2 border-r", children: "Redemption gateway" }), _jsx("div", { className: "flex flex-row items-center p-2 gap-x-2", children: _jsx(AddressView, { address: redemptionGateway, compact: true }) })] }), _jsx(PriceUpdates, { priceUpdates: priceUpdates })] }));
};
export default RwaPreview;
